import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

import {MAX_COLUMNS} from "../../../../eoec/ec/impl/Reporting/reportResultColumns";

// One row of a report result.
//
// BOTH REGISTRIES OR NEITHER. EnterpriseComponentClassFactory maps the name to a CLASS and
// EnterpriseComponentMetadataClassFactory maps it to THIS -- registering only the first gets
// "metadataClass is not a constructor", which is a blank page rather than a degraded grid, because
// the missing name returns undefined and the constructor calls `new undefined()`. It has happened
// in this app twice; the second time was the hierarchies rail, this September.
//
// POSITIONS, NOT NAMES. A report's columns change with every run and attributes are declared once,
// so the row carries c0..c11 and the applet decides what each is called. Everything is a String:
// these are for DISPLAY, the server did the arithmetic, and a number re-parsed in the browser is a
// second answer waiting to disagree about rounding with the one the database gave.
class ReportResultEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "ReportResult";
        this.defaultCacheSize = 50;

        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata(
            "USID", false, false, false, false, null, null, null, null, null, null, "UUID", null, false,
        );

        // THE RECORD THIS ROW IS, on a listing. Declared rather than smuggled: the grid reads a
        // cell through the EC, and an attribute the metadata does not know is not readable there.
        // Underscored because it is not one of the reader's columns and must never be headed as
        // one -- it exists so a row can be opened, not shown.
        this.attributes["_record"] = new EnterpriseComponentAttributeMetadata(
            "_record", false, false, false, false, null, null, null, null, null, null, "UUID", null, false,
        );

        for (let position = 0; position < MAX_COLUMNS; position++) {
            this.attributes[`c${position}`] = new EnterpriseComponentAttributeMetadata(
                `c${position}`, false, false, false, false, null, null, null, 4000, null, null,
                "String", null, false,
            );
        }
    }
}

export default ReportResultEnterpriseComponentMetadata;
